export default __webpack_public_path__ + "static/media/3.e0b896a2.svg";